import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CreateReferral from "@/pages/CreateReferral";
import ReferralView from "@/pages/ReferralView";
import History from "@/pages/History";
import Templates from "@/pages/Templates";
import Profile from "@/pages/Profile";
import Subscription from "@/pages/Subscription";
import PublicReferral from "@/pages/PublicReferral";
import CentreDashboard from "@/pages/CentreDashboard";
import Admin from "@/pages/Admin";
import CreatePrescription from "@/pages/CreatePrescription";
import PrescriptionView from "@/pages/PrescriptionView";
import PrescriptionHistory from "@/pages/PrescriptionHistory";
import PharmacyDashboard from "@/pages/PharmacyDashboard";
import InviteActivate from "@/pages/InviteActivate";
import PrescriptionVerify from "@/pages/PrescriptionVerify";
import ResetPassword from "@/pages/ResetPassword";
import Patients from "@/pages/Patients";

function RoleHome() {
  const { user } = useAuth();
  if (user?.role === "admin") return <Navigate to="/admin" replace />;
  if (user?.role === "radiology_centre") return <Navigate to="/centre" replace />;
  if (user?.role === "pharmacy") return <Navigate to="/pharmacy" replace />;
  return <Navigate to="/dashboard" replace />;
}

function Shell({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/r/:token" element={<PublicReferral />} />
            <Route path="/verify/:token" element={<PrescriptionVerify />} />
            <Route path="/invite/:token" element={<InviteActivate />} />
            <Route path="/reset/:token" element={<ResetPassword />} />
            <Route path="/home" element={<ProtectedRoute><RoleHome /></ProtectedRoute>} />

            <Route path="/dashboard" element={<Shell roles={["doctor"]}><Dashboard /></Shell>} />
            <Route path="/referrals/new" element={<Shell roles={["doctor"]}><CreateReferral /></Shell>} />
            <Route path="/referrals/:id/edit" element={<Shell roles={["doctor"]}><CreateReferral /></Shell>} />
            <Route path="/referrals/:id" element={<Shell roles={["doctor", "radiology_centre"]}><ReferralView /></Shell>} />
            <Route path="/history" element={<Shell roles={["doctor"]}><History /></Shell>} />
            <Route path="/prescriptions/new" element={<Shell roles={["doctor"]}><CreatePrescription /></Shell>} />
            <Route path="/prescriptions/:id/edit" element={<Shell roles={["doctor"]}><CreatePrescription /></Shell>} />
            <Route path="/prescriptions/:id" element={<Shell roles={["doctor", "pharmacy"]}><PrescriptionView /></Shell>} />
            <Route path="/prescriptions" element={<Shell roles={["doctor"]}><PrescriptionHistory /></Shell>} />
            <Route path="/templates" element={<Shell roles={["doctor"]}><Templates /></Shell>} />
            <Route path="/patients" element={<Shell roles={["doctor"]}><Patients /></Shell>} />
            <Route path="/profile" element={<Shell roles={["doctor", "radiology_centre", "pharmacy"]}><Profile /></Shell>} />
            <Route path="/billing" element={<Shell roles={["doctor"]}><Subscription /></Shell>} />
            <Route path="/subscription" element={<Shell roles={["doctor"]}><Subscription /></Shell>} />
            <Route path="/centre" element={<Shell roles={["radiology_centre"]}><CentreDashboard /></Shell>} />
            <Route path="/pharmacy" element={<Shell roles={["pharmacy"]}><PharmacyDashboard /></Shell>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
